import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../_services/authentication.service';
import { User } from '../../models/user.model';


@Component({
  selector: 'app-nav-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})


export class NavMenuComponent {
  isExpanded = false;
  userName: string;
  CarteraProcesada: number;
  currentUser: User;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
    this.userName = 'Neptuno'
    this.CarteraProcesada = (1000 - 200);
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  get isAdmin() {
    return this.currentUser && this.currentUser.fkUserRole === 1;
  }
  get isCoordinator() {
    return this.currentUser && this.currentUser.fkUserRole === 2;
  }
  get isAnalyst() {
    return this.currentUser && this.currentUser.fkUserRole === 3;
  }
  get isAssistant() {
    return this.currentUser && this.currentUser.fkUserRole === 4;
  }
  get isOfficeUser() {
    return this.currentUser && this.currentUser.fkUserRole === 5;
  }
  get isAgent() {
    return this.currentUser && this.currentUser.fkUserRole === 6;
  }
  get isManagement() {
    return this.currentUser && this.currentUser.fkUserRole === 7;
  }

  logout() {   
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
